import useJoyStickNavigation, {
  joystickEvent,
} from "hooks/UseJoyStickNavigation";
import styles from "./QuestionairePicker.module.scss";
import Fade from "components/UI/Animations/Fade/Fade";
import Button from "components/UI/Button/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/pro-regular-svg-icons";
import { useEffect, useState } from "react";
import useGetDatasets from "actions/quiz/useGetDatasets";
import { useNavigate } from "@tanstack/react-router";
import useSetActiveDataset from "actions/quiz/useSetActiveDataset";

export default function QuestionairePicker() {
  const [selectedItem, setSelectedItem] = useState(0);

  const { data: datasetsData } = useGetDatasets();
  const navigate = useNavigate();
  const { mutateAsync: setActiveDataset } = useSetActiveDataset();

  const handleJoyStick = (event: joystickEvent) => {
    switch (event) {
      case "left":
        break;
      case "right":
        break;
      case "up":
        setSelectedItem((prev) => {
          if (prev === -1) {
            return prev;
          }
          return prev - 1;
        });
        break;
      case "down":
        setSelectedItem((prev) => {
          if (datasetsData?.length === prev + 1) {
            return prev;
          }
          return prev + 1;
        });
        break;
      case "enter":
        if (selectedItem === -1) {
          navigate({ to: "/" });
          return;
        }
        if (datasetsData) {
          setActiveDataset(datasetsData[selectedItem].id);
          navigate({ to: "/" });
        }
        break;
      default:
        break;
    }
  };

  useJoyStickNavigation(handleJoyStick);

  return (
    <Fade>
      <div className={styles.questionairePicker}>
        <Button variant={selectedItem === -1 ? "secondary" : "primary"}>
          <FontAwesomeIcon icon={faChevronLeft} /> Terug
        </Button>
        <div className={styles.center}>
          <h1>Kies een vragenlijst</h1>
          {datasetsData?.map((dataset, index) => {
            return (
              <div
                className={`${styles.questionaireCard} ${selectedItem === index ? styles.selected : ""} ${dataset.active ? styles.active : ""}`}
                key={dataset.id}
              >
                <div className={styles.circle} />
                <p>{dataset.name}</p>
              </div>
            );
          })}
        </div>
      </div>
    </Fade>
  );
}
